module.exports = __webpack_public_path__ + "img/1515623038.8bc4bc1c.jpg";